import React from "react";
import Image from "next/image";
interface BenefitCardProps {
    icon: string;
    title: string;
    backgroundColor: string;
    textColor: string;
    borderColor?: string;
}

interface BenefitProps {
    title: JSX.Element;
    benefitCards: BenefitCardProps[];
}

const BenefitsCard: React.FC<BenefitProps> = (props: BenefitProps) => {
    const { title, benefitCards } = props;
    return (
        <div className="lg:max-w-6xl mx-auto w-full mt-20 mb-10">
            <div className="text-center lg:text-5xl font-bold text-gray-700 text-3xl">{title}</div>
            <div className="flex flex-col gap-7 md:flex-row mt-10 w-full">
                {benefitCards.map((benefitCard) => (
                    <div
                        key={benefitCard.title}
                        className="px-6 py-10 flex flex-col items-center rounded-xl md:mx-0 mx-5 flex-1 border-solid border-2"
                        style={{ background: benefitCard.backgroundColor, borderColor: benefitCard.borderColor }}
                    >
                        <div className="flex items-center justify-center w-10 h-10">
                            <Image src={benefitCard.icon} alt="" width={40} height={40} />
                        </div>
                        <p className="mt-4 font-bold text-2xl text-center flex-1" style={{ color: benefitCard.textColor }}>
                            {benefitCard.title}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BenefitsCard;
